/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Allocation_Form_Minimum_Commitment_HintInputs */

const en_admin_allocation_form_minimum_commitment_hint = /** @type {(inputs: Admin_Allocation_Form_Minimum_Commitment_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allocation cannot be canceled before the given number of months.`)
};

const de_admin_allocation_form_minimum_commitment_hint = /** @type {(inputs: Admin_Allocation_Form_Minimum_Commitment_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Zuweisung kann nicht vor der angegebenen Anzahl von Monaten gekündigt werden.`)
};

const es_admin_allocation_form_minimum_commitment_hint = /** @type {(inputs: Admin_Allocation_Form_Minimum_Commitment_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La asignación no puede cancelarse antes del número de meses indicado.`)
};

const fr_admin_allocation_form_minimum_commitment_hint = /** @type {(inputs: Admin_Allocation_Form_Minimum_Commitment_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'attribution ne peut pas être résiliée avant le nombre de mois indiqué.`)
};

const nl_admin_allocation_form_minimum_commitment_hint = /** @type {(inputs: Admin_Allocation_Form_Minimum_Commitment_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toewijzing kan niet worden beëindigd vóór het opgegeven aantal maanden.`)
};

/** @type {(inputs: Admin_Allocation_Form_Minimum_Commitment_HintInputs) => LocalizedString} */
const it_admin_allocation_form_minimum_commitment_hint = en_admin_allocation_form_minimum_commitment_hint;

/** @type {(inputs: Admin_Allocation_Form_Minimum_Commitment_HintInputs) => LocalizedString} */
const pt_br2_admin_allocation_form_minimum_commitment_hint = en_admin_allocation_form_minimum_commitment_hint;

/** @type {(inputs: Admin_Allocation_Form_Minimum_Commitment_HintInputs) => LocalizedString} */
const pl_admin_allocation_form_minimum_commitment_hint = en_admin_allocation_form_minimum_commitment_hint;

/** @type {(inputs: Admin_Allocation_Form_Minimum_Commitment_HintInputs) => LocalizedString} */
const hu_admin_allocation_form_minimum_commitment_hint = en_admin_allocation_form_minimum_commitment_hint;

/** @type {(inputs: Admin_Allocation_Form_Minimum_Commitment_HintInputs) => LocalizedString} */
const ro_admin_allocation_form_minimum_commitment_hint = en_admin_allocation_form_minimum_commitment_hint;

/**
* | output |
* | --- |
* | "Allocation cannot be canceled before the given number of months." |
*
* @param {Admin_Allocation_Form_Minimum_Commitment_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocation_form_minimum_commitment_hint = /** @type {((inputs?: Admin_Allocation_Form_Minimum_Commitment_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocation_Form_Minimum_Commitment_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocation_form_minimum_commitment_hint(inputs)
	if (locale === "de") return de_admin_allocation_form_minimum_commitment_hint(inputs)
	if (locale === "es") return es_admin_allocation_form_minimum_commitment_hint(inputs)
	if (locale === "fr") return fr_admin_allocation_form_minimum_commitment_hint(inputs)
	if (locale === "nl") return nl_admin_allocation_form_minimum_commitment_hint(inputs)
	if (locale === "it") return it_admin_allocation_form_minimum_commitment_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocation_form_minimum_commitment_hint(inputs)
	if (locale === "pl") return pl_admin_allocation_form_minimum_commitment_hint(inputs)
	if (locale === "hu") return hu_admin_allocation_form_minimum_commitment_hint(inputs)
	return ro_admin_allocation_form_minimum_commitment_hint(inputs)
});
export { admin_allocation_form_minimum_commitment_hint as "admin.allocation_form.minimum_commitment_hint" }